module.exports = __webpack_public_path__ + "static/media/clockD.88b801aa.png";